export enum SlideTimingKind {
  Timed = 'timed',
  Fixed = 'fixed',
  Media = 'media'
}
